import classNames from 'classnames';
import type { ElementType, ComponentPropsWithoutRef, ReactNode } from 'react';
import { createElement } from 'react';

import styles from './Container.module.scss';

type ContainerProps<T extends ElementType> = {
  as?: T;
  className?: string;
  children?: ReactNode;
  noPadding?: boolean;
} & ComponentPropsWithoutRef<T>;

export function Container<T extends ElementType = 'div'>({
  as,
  className,
  children,
  noPadding,
  ...rest
}: ContainerProps<T>) {
  const Component = as || 'div';

  return createElement(
    Component,
    {
      className: classNames(styles.content, className, { [styles.noPadding]: noPadding }),
      ...rest,
    },
    children,
  );
}
